import { localDate } from '@/platform/lib/utils';
import { Tooltip, TooltipContent, TooltipTrigger } from '@/platform/ui';
import {
    ArrowTopRightOnSquareIcon,
    CakeIcon,
    ExclamationTriangleIcon,
    IdentificationIcon,
} from '@heroicons/react/24/outline';

const EmployeeCard = ({ employment }) => {
    const employee = employment?.employee;

    if (!employee) {
        return null;
    }

    return (
        <div className='min-w-0'>
            <div className='flex items-center gap-1.5'>
                <span className='text-sm font-semibold text-gray-900'>
                    {employee.name}
                </span>

                {employment.employment_number && (
                    <Tooltip>
                        <TooltipTrigger asChild>
                            <span
                                tabIndex={0}
                                className='text-xs text-gray-500'
                            >
                                ({employment.employment_number})
                            </span>
                        </TooltipTrigger>
                        <TooltipContent>
                            Werknemer heeft meerdere dienstverbanden
                        </TooltipContent>
                    </Tooltip>
                )}

                {employment.simultaneous_employments && (
                    <Tooltip>
                        <TooltipTrigger asChild>
                            <span
                                tabIndex={0}
                                role='img'
                                aria-label='Werknemer heeft gelijktijdige dienstverbanden'
                                className='inline-flex'
                            >
                                <ExclamationTriangleIcon className='size-4 text-red-600' />
                            </span>
                        </TooltipTrigger>
                        <TooltipContent>
                            Werknemer heeft gelijktijdige dienstverbanden
                        </TooltipContent>
                    </Tooltip>
                )}

                <a
                    href={`/employees/${employee.id}`}
                    target='_blank'
                    rel='noreferrer'
                    aria-label='Open werknemer'
                    className='text-primary-500 hover:text-primary-600 inline-flex'
                >
                    <ArrowTopRightOnSquareIcon className='size-4' />
                </a>
            </div>

            <div className='mt-1 flex items-center gap-3 text-xs text-gray-500'>
                {employee.bsn && (
                    <span className='flex items-center gap-1'>
                        <IdentificationIcon className='size-4' />
                        {employee.bsn}
                    </span>
                )}
                {employee.age != null && (
                    <Tooltip>
                        <TooltipTrigger asChild>
                            <span
                                tabIndex={0}
                                className='flex items-center gap-1'
                            >
                                <CakeIcon className='size-4' />
                                {employee.age} jr.
                            </span>
                        </TooltipTrigger>
                        <TooltipContent>
                            Geboortedatum:{' '}
                            {localDate(employee.birth_date) || '-'}
                        </TooltipContent>
                    </Tooltip>
                )}
            </div>
        </div>
    );
};

export default EmployeeCard;
